"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalogDateDataset = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type guard checking whether object is an instance of ICatalogDateDataset.
 *
 * @public
 */
function isCatalogDateDataset(obj) {
    return !isEmpty_1.default(obj) && obj.type === "dateDataset";
}
exports.isCatalogDateDataset = isCatalogDateDataset;
//# sourceMappingURL=index.js.map